import { io, type Socket } from 'socket.io-client';

const RAW_SERVER_URL = import.meta.env.VITE_SERVER_URL ?? 'http://localhost:3001';
const SERVER_URL = RAW_SERVER_URL === '' ? undefined : RAW_SERVER_URL;

let socketInstance: Socket | null = null;

export function getSocket(): Socket {
  if (socketInstance) {
    return socketInstance;
  }
  socketInstance = io(SERVER_URL, {
    transports: ['websocket'],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    randomizationFactor: 0.5,
    timeout: 10000,
  });
  bindVisibilityReconnect(socketInstance);
  return socketInstance;
}

function bindVisibilityReconnect(socket: Socket): void {
  if (typeof document === 'undefined') return;
  const tryReconnect = (): void => {
    if (document.visibilityState !== 'visible') return;
    if (socket.connected) return;
    socket.connect();
  };
  document.addEventListener('visibilitychange', tryReconnect);
  window.addEventListener('focus', tryReconnect);
  window.addEventListener('pageshow', tryReconnect);
}
